import { FileUpload as AFileUpload } from '@ark-ui/solid/file-upload';
import { IconTrash } from '@bbr/icons/trash-outline';
import { IconUpload } from '@bbr/icons/upload-outline';
import { For } from 'solid-js';
import { cn } from 'tailwind-variants';
import { Button } from './button.tsx';
import { Field } from './field.tsx';
import type { ComponentProps } from 'solid-js';

export function FileUpload(props: ComponentProps<typeof AFileUpload.Root>) {
	return (
		<Field name={props.name ?? ''} invalid={!!props.invalid}>
			<AFileUpload.Root {...props} class={cn('group/field flex w-full flex-col justify-start gap-1', props.class)}>
				<AFileUpload.HiddenInput />
				{props.children}
			</AFileUpload.Root>
		</Field>
	);
}

FileUpload.Label = (props: ComponentProps<typeof AFileUpload.Label>) => (
	<AFileUpload.Label {...props} class={cn('flex gap-1 text-lg font-medium', props.class)}>
		{props.children}
		<Field.Required />
	</AFileUpload.Label>
);

FileUpload.Trigger = (props: ComponentProps<typeof AFileUpload.Trigger>) => <AFileUpload.Trigger {...props} />;

FileUpload.Dropzone = (props: ComponentProps<typeof AFileUpload.Dropzone>) => (
	<AFileUpload.Dropzone class="my-2 flex cursor-pointer items-start gap-2 rounded-lg border border-dashed border-zinc-300 p-4 text-zinc-600 transition-all hover:border-yellow-500 hover:bg-yellow-500/20 data-dragging:border-yellow-500 data-dragging:bg-yellow-500/20 dark:border-zinc-700 dark:text-zinc-400">
		<IconUpload class="relative top-1" />
		<div>{props.children}</div>
	</AFileUpload.Dropzone>
);

FileUpload.Items = () => (
	<AFileUpload.ItemGroup class="flex flex-col gap-2">
		<AFileUpload.Context>
			{(context) => (
				<For each={context().acceptedFiles}>
					{(file) => (
						<AFileUpload.Item file={file} class="flex items-center gap-2 rounded-lg text-sm">
							<AFileUpload.ItemPreview type="image/*" class="grid aspect-square shrink basis-32 place-items-center">
								<AFileUpload.ItemPreviewImage />
							</AFileUpload.ItemPreview>
							<div class="grow">
								<AFileUpload.ItemName class="w-full font-semibold" />
								<AFileUpload.ItemSizeText class="text-xs" />
							</div>
							<AFileUpload.ItemDeleteTrigger
								asChild={(p) => (
									// @ts-expect-error too complex
									<Button {...p()} rounding="md" appearance="subtle" size="md" action="danger" />
								)}
							>
								<IconTrash />
							</AFileUpload.ItemDeleteTrigger>
						</AFileUpload.Item>
					)}
				</For>
			)}
		</AFileUpload.Context>
	</AFileUpload.ItemGroup>
);
